import {
    GET_DASHBOARD_DETAILS,
    GET_DASHBOARD_DETAILS_SUCCESS,
    GET_DASHBOARD_DETAILS_FAILURE,
    GET_BANNERS,
    GET_BANNERS_SUCCESS,
    GET_BANNERS_FAILURE,
    GET_INCBOT_INTERVIEW_MONTHLY_STATS,
    GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS,
    GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE,
    GET_DASHBOARD_INTERVIEWS,
    GET_DASHBOARD_INTERVIEWS_SUCCESS,
    GET_DASHBOARD_INTERVIEWS_FAILURE,
    GET_FINAL_OUTCOMES,
    GET_FINAL_OUTCOMES_SUCCESS,
    GET_FINAL_OUTCOMES_FAILURE,
    GET_FEEDBACK_STATUS,
    GET_FEEDBACK_STATUS_SUCCESS,
    GET_FEEDBACK_STATUS_FAILURE,
    GET_POSITIONS_SUMMARY,
    GET_POSITIONS_SUMMARY_SUCCESS,
    GET_POSITIONS_SUMMARY_FAILURE,
    GET_TOP_POSITIONS,
    GET_TOP_POSITIONS_SUCCESS,
    GET_TOP_POSITIONS_FAILURE,
    GET_POSITION_ANALYTICS,
    GET_POSITION_ANALYTICS_SUCCESS,
    GET_POSITION_ANALYTICS_FAILURE,
    GET_INTERVIEW_COMPLETED,
    GET_INTERVIEW_COMPLETED_SUCCESS,
    GET_INTERVIEW_COMPLETED_FAILURE,
    GET_TOTAL_INTERVIEWS,
    GET_TOTAL_INTERVIEWS_SUCCESS,
    GET_TOTAL_INTERVIEWS_FAILURE,
    GET_INTERVIEW_COMPLETED_SUMMARY,
    GET_INTERVIEW_COMPLETED_SUMMARY_SUCCESS,
    GET_INTERVIEW_COMPLETED_SUMMARY_FAILURE,
    GET_WHATS_NEW,
    GET_WHATS_NEW_SUCCESS,
    GET_WHATS_NEW_FAILURE,
    GET_DASHBOARD_USER_POSITIONS,
    GET_DASHBOARD_USER_POSITIONS_SUCCESS,
    GET_DASHBOARD_USER_POSITIONS_FAILURE,
    GET_DASHBOARD_SUBUSER_LIST,
    GET_DASHBOARD_SUBUSER_LIST_SUCCESS,
    GET_DASHBOARD_SUBUSER_LIST_FAILURE,
} from './types';
export const getDashboardDetails = (payload) => ({
    type: GET_DASHBOARD_DETAILS,
    payload,
});
export const getDashboardDetailsSuccess = (payload) => ({
    type: GET_DASHBOARD_DETAILS_SUCCESS,
    payload,
});
export const getDashboardDetailsFailure = () => ({
    type: GET_DASHBOARD_DETAILS_FAILURE,
});

export const getBanners = () => ({
    type: GET_BANNERS,
});
export const getBannersSuccess = (payload) => ({
    type: GET_BANNERS_SUCCESS,
    payload,
});
export const getBannersFailure = () => ({
    type: GET_BANNERS_FAILURE,
});

export const getIncbotInterviewMonthlyStats = (payload) => ({
    type: GET_INCBOT_INTERVIEW_MONTHLY_STATS,
    payload,
});
export const getIncbotInterviewMonthlyStatsSuccess = (payload) => ({
    type: GET_INCBOT_INTERVIEW_MONTHLY_STATS_SUCCESS,
    payload,
});
export const getIncbotInterviewMonthlyStatsFailure = () => ({
    type: GET_INCBOT_INTERVIEW_MONTHLY_STATS_FAILURE,
});

export const getDashboardInterviews = (payload) => ({
    type: GET_DASHBOARD_INTERVIEWS,
    payload,
});

export const getDashboardInterviewsSuccess = (payload) => ({
    type: GET_DASHBOARD_INTERVIEWS_SUCCESS,
    payload,
});

export const getDashboardInterviewsFailure = () => ({
    type: GET_DASHBOARD_INTERVIEWS_FAILURE,
});

export const getFinalOutcomes = (payload) => ({
    type: GET_FINAL_OUTCOMES,
    payload,
});

export const getFinalOutcomesSuccess = (payload) => ({
    type: GET_FINAL_OUTCOMES_SUCCESS,
    payload,
});

export const getFinalOutcomesFailure = () => ({
    type: GET_FINAL_OUTCOMES_FAILURE,
});

export const getFeedbackStatus = (payload) => ({
    type: GET_FEEDBACK_STATUS,
    payload,
});

export const getFeedbackStatusSuccess = (payload) => ({
    type: GET_FEEDBACK_STATUS_SUCCESS,
    payload,
});

export const getFeedbackStatusFailure = () => ({
    type: GET_FEEDBACK_STATUS_FAILURE,
});

export const getPositionsSummary = (payload) => ({
    type: GET_POSITIONS_SUMMARY,
    payload,
});

export const getPositionsSummarySuccess = (payload) => ({
    type: GET_POSITIONS_SUMMARY_SUCCESS,
    payload,
});

export const getPositionsSummaryFailure = () => ({
    type: GET_POSITIONS_SUMMARY_FAILURE,
});

export const getTopPositions = (payload) => ({
    type: GET_TOP_POSITIONS,
    payload,
});

export const getTopPositionsSuccess = (payload) => ({
    type: GET_TOP_POSITIONS_SUCCESS,
    payload,
});

export const getTopPositionsFailure = () => ({
    type: GET_TOP_POSITIONS_FAILURE,
});

export const getPositionAnalytics = (payload) => ({
    type: GET_POSITION_ANALYTICS,
    payload,
});

export const getPositionAnalyticsSuccess = (payload) => ({
    type: GET_POSITION_ANALYTICS_SUCCESS,
    payload,
});

export const getPositionAnalyticsFailure = () => ({
    type: GET_POSITION_ANALYTICS_FAILURE,
});

export const getInterviewCompleted = (payload) => ({
    type: GET_INTERVIEW_COMPLETED,
    payload,
});

export const getInterviewCompletedSuccess = (payload) => ({
    type: GET_INTERVIEW_COMPLETED_SUCCESS,
    payload,
});

export const getInterviewCompletedFailure = () => ({
    type: GET_INTERVIEW_COMPLETED_FAILURE,
});

export const getTotalInterviews = (payload) => ({
    type: GET_TOTAL_INTERVIEWS,
    payload,
});

export const getTotalInteviewsSuccess = (payload) => ({
    type: GET_TOTAL_INTERVIEWS_SUCCESS,
    payload,
});

export const getTotalInterviewsFailure = () => ({
    type: GET_TOTAL_INTERVIEWS_FAILURE,
});

export const getInterviewCompletedSummary = (payload) => ({
    type: GET_INTERVIEW_COMPLETED_SUMMARY,
    payload,
});

export const getInterviewCompletedSummarySuccess = (payload) => ({
    type: GET_INTERVIEW_COMPLETED_SUMMARY_SUCCESS,
    payload,
});

export const getInterviewCompletedSummaryFailure = () => ({
    type: GET_INTERVIEW_COMPLETED_SUMMARY_FAILURE,
});

export const getWhatsNew = (payload) => ({
    type: GET_WHATS_NEW,
    payload,
});
export const getWhatsNewSuccess = (payload) => ({
    type: GET_WHATS_NEW_SUCCESS,
    payload,
});
export const getWhatsNewFailure = () => ({
    type: GET_WHATS_NEW_FAILURE,
});

export const getDashboardUserPositions = () => ({
    type: GET_DASHBOARD_USER_POSITIONS,
});
export const getDashboardUserPositionsSuccess = (payload) => ({
    type: GET_DASHBOARD_USER_POSITIONS_SUCCESS,
    payload,
});
export const getDashboardUserPositionsFailure = () => ({
    type: GET_DASHBOARD_USER_POSITIONS_FAILURE,
});

export const getDashboardSubuserList = () => ({
    type: GET_DASHBOARD_SUBUSER_LIST,
});
export const getDashboardSubuserListSuccess = (payload) => ({
    type: GET_DASHBOARD_SUBUSER_LIST_SUCCESS,
    payload,
});
export const getDashboardSubuserListFailure = () => ({
    type: GET_DASHBOARD_SUBUSER_LIST_FAILURE,
});
